/**
 * Shared Blockly chrome colours. Overlay fills must stay high-contrast on
 * RM container hues (`#003B49` / `#005C53`).
 */
export const LOOP_BLOCK_COLOUR = "#A5D6A7";

/** Template-narrowing Δ + effective cardinality (on dark RM blocks). */
export const SLOT_OVERLAY_DELTA_FILL = "#FDE68A";

/** Struck-through RM cardinality next to the overlay. */
export const SLOT_OVERLAY_RM_FILL = "#E2E8F0";

/** Hover outline on collapsed ZipEHR / generic nodes. */
export const COLLAPSED_HOVER_OUTLINE = "#FDE68A";
